export default __webpack_public_path__ + "static/media/folder_white_icon.a974623a.svg";